// src/utils/constants.ts

export const LABELS = [
  { id: 'urgent',       name: 'Urgent',        color: '#ef4444' },
  { id: 'highpriority', name: 'High Priority', color: '#f97316' },
  { id: 'admin',        name: 'Admin',         color: '#10b981' },
  { id: 'meeting',      name: 'Meeting',       color: '#ec4899' },
  { id: 'cm',           name: 'CM Office',     color: '#eab308' },
  { id: 'field',        name: 'Field Visit',   color: '#06b6d4' },
  { id: 'finance',      name: 'Finance',       color: '#f59e0b' },
  { id: 'legal',        name: 'Legal',         color: '#8b5cf6' },
  { id: 'report',       name: 'Report',        color: '#3b82f6' },
  { id: 'confidential', name: 'Confidential',  color: '#6b7280' },
  { id: 'followup',     name: 'Follow-up',     color: '#14b8a6' },
  { id: 'completed',    name: 'Completed',     color: '#22c55e' },
  { id: 'hr',           name: 'HR',            color: '#a855f7' },
  { id: 'it',           name: 'IT',            color: '#0ea5e9' },
  { id: 'management',   name: 'Management',    color: '#f43f5e' },
] as const;

// Department filter (Assign Task header) — filters by the task's existing
// Project (listId), no separate field needed.
export const DEPARTMENTS = [
  { id: 'work',     label: 'Work',     icon: '🏛️' },
  { id: 'legal',    label: 'Legal',    icon: '⚖️' },
  { id: 'finance',  label: 'Finance',  icon: '💰' },
  { id: 'personal', label: 'Personal', icon: '👤' },
] as const;

// Priority filter (Assign Task header) — colored dot per existing tier.
export const PRIORITY_DOT: Record<string, string> = {
  Emergency: '🔴',
  High:      '🟠',
  Medium:    '🟡',
  Normal:    '🔵',
  Low:       '⚪',
};

// Server-computed priority tiers (FEATURES.md §3/§6) — read-only,
// never client-set. Keyed by the string the API returns.
export const PRIORITY = {
  Emergency: { c: '#ef4444', label: 'Emergency' },
  High:      { c: '#f97316', label: 'High' },
  Medium:    { c: '#f59e0b', label: 'Medium' },
  Normal:    { c: '#3b82f6', label: 'Normal' },
  Low:       { c: '#6b7280', label: 'Low' },
} as const;

// Status colors not otherwise covered by KANBAN_COLS (Rejected/Returned aren't
// kanban columns — they're shown as banners, per FEATURES.md §6).
export const STATUS_COLORS: Record<string, string> = {
  Draft:     '#f59e0b',
  Completed: '#10b981',
  Rejected:  '#991b1b',
  Returned:  '#f59e0b',
};

export const KANBAN_COLS = [
  { id: 'Pending',     label: 'Pending',      color: '#f59e0b', dot: '#f59e0b' },
  { id: 'Accepted',    label: 'Accepted',     color: '#06b6d4', dot: '#06b6d4' },
  { id: 'In Progress', label: 'In Progress',  color: '#3b82f6', dot: '#3b82f6' },
  { id: 'Review',      label: 'Review',       color: '#8b5cf6', dot: '#8b5cf6' },
  { id: 'Completed',   label: 'Completed',    color: '#10b981', dot: '#10b981' },
] as const;

export const SIDEBAR_LISTS = [
  { id: 'assign',    label: 'Assign Task',      icon: '📝' },
  { id: 'mine',      label: 'Received Tasks',   icon: '📥' },
  { id: 'important', label: 'Important',        icon: '⭐' },
  { id: 'week',      label: 'This Week',        icon: '🗓️' },
  { id: 'all',       label: 'All Tasks',        icon: '📋' },
  { id: 'done',      label: 'Completed',        icon: '✅' },
] as const;

export const PROJECT_LISTS = [
  { id: 'work',     label: 'Work',     icon: '🏛️', color: '#3b82f6' },
  { id: 'legal',    label: 'Legal',    icon: '⚖️',  color: '#8b5cf6' },
  { id: 'finance',  label: 'Finance',  icon: '💰', color: '#f59e0b' },
  { id: 'personal', label: 'Personal', icon: '👤', color: '#ec4899' },
] as const;

export const RECURS = [null, 'daily', 'weekly', 'monthly'] as const;

export const ESTIMATE_OPTIONS = [
  { value: '',    label: 'No estimate' },
  { value: '15',  label: '15 min' },
  { value: '30',  label: '30 min' },
  { value: '60',  label: '1 hour' },
  { value: '120', label: '2 hours' },
  { value: '240', label: 'Half day' },
  { value: '480', label: 'Full day' },
] as const;

export const VIEWS = [
  { id: 'list',     label: 'List',     icon: '≡'  },
  { id: 'kanban',   label: 'Board',    icon: '⊞'  },
  { id: 'calendar', label: 'Calendar', icon: '▦'  },
  { id: 'matrix',   label: 'Matrix',   icon: '⊟'  },
  { id: 'habit',    label: 'Habits',   icon: '🔁' },
  { id: 'report',   label: 'Report',   icon: '📊' },
  { id: 'hierarchy', label: 'Hierarchy', icon: '🏛️' },
] as const;

export const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const HABIT_COLORS = ['#f59e0b','#3b82f6','#10b981','#8b5cf6','#ef4444','#06b6d4'];
